import CircularProgress from "@mui/material/CircularProgress"
import { useNavigate } from "react-router-dom"
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import Box from '@mui/material/Box'

import { useAppliancePlans, useCreateAppliancePlan } from "../../hooks/use-appliance-plan"
import { ErrorMessage } from "../../views/wizard/steps/components/ErrorMessage"
import CustomButton from "../custom-button"

export default function FinishButton({
    applianceId,
    estateId,
    disabled,
}: {
    applianceId: number
    estateId: number
    disabled?: boolean
}) {
    const navigate = useNavigate()

    const mutation = useCreateAppliancePlan(applianceId, appliancePlanId => {
        navigate(`/estate/${estateId}/appliance/${applianceId}/plan/${appliancePlanId}`)
    })

    const { data, error, status } = useAppliancePlans(applianceId)

    if (status === 'pending') {
        return <CircularProgress />
    }

    if (error) {
        return <ErrorMessage>{error.message}</ErrorMessage>
    }

    const appliancePlanId = data && data.length > 0 ?
        data.find(plan => plan.active === true).id ?? data[0].id
        : null

    return (
        <>
            <CustomButton
                text="Nastavit sprchování"
                disabled={disabled}
                endIcon={<ChevronRightRoundedIcon />}
                onClick={() => {
                    if (appliancePlanId) {
                        navigate(`/estate/${estateId}/appliance/${applianceId}/plan/${appliancePlanId}`)
                    } else {
                        mutation.mutate({
                            name: 'Můj plán',
                            active: true
                        })
                    }
                }}
            />
            {mutation.isError &&
                <Box sx={{ margin: '1.5rem 0 0 0' }}>
                    Došlo k chybě: {mutation.error.message}
                </Box>
            }
        </>
    )
}
